import SignupForm from './SignupForm';
import SignUp from './Signup';

export { SignUp, SignupForm };
